import { AxiosError } from 'axios';

export const isAxiosCancellationError = (error: unknown) => {
    const axiosError = error as AxiosError;

    return axiosError.name === 'CanceledError';
};
